<template>
  <div data-testid="balances-error" class="balances-error">
    <Heading class="balances-error__title" :level="3">{{ title }}</Heading>
    <BaseText
      class="balances-error__description"
      size="xs"
      :color="NebraskaColors.textSecondary"
    >
      {{ description }}
    </BaseText>
    <ButtonSecondary
      label="Tentar novamente"
      icon="EA0130"
      icon-position="right"
      @click="reload"
    />
  </div>
</template>

<script lang="ts">
import { Component, Vue, Emit } from 'vue-property-decorator';
import { BaseText, ButtonSecondary, Heading } from '@warrenbrasil/nebraska-web';
import { NebraskaColors } from '@warrenbrasil/nebraska-tokens-web';

@Component({
  components: {
    Heading,
    BaseText,
    ButtonSecondary
  }
})
export default class BalancesError extends Vue {
  @Emit('reload')
  reload() {}

  readonly NebraskaColors = NebraskaColors;

  title = 'Houve um problema ao carregar o saldo';
  description = 'Aguarde um momento e tente novamente';
}
</script>

<style lang="less" scoped>
.balances-error {
  max-width: 250px;
  margin-bottom: @size-spacing-x900;

  &__title {
    margin-bottom: @size-spacing-x150;
  }
  &__description {
    margin-bottom: @size-spacing-x450;
  }
}
</style>
